import { Link, useLocation } from "react-router-dom";
import { BarChart3 } from "lucide-react";

export const Nav = () => {
  const isHome = useLocation().pathname === "/";
  const anchor = (id) => (isHome ? `#${id}` : `/#${id}`);

  return (
    <nav className="border-b border-line bg-navy/90 backdrop-blur sticky top-0 z-40" data-testid="site-nav">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-home-link">
          <BarChart3 className="w-6 h-6 text-cy" strokeWidth={2} />
          <span className="font-display tracking-wider text-sm text-white uppercase" data-testid="brand-name">
            PRIVATECREDIT.COM.AU
          </span>
          <span className="hidden md:inline-block text-[10px] font-mono text-cy bg-cy/10 px-2 py-0.5 rounded border border-cy/20">
            AU BENCHMARK TERMINAL
          </span>
        </Link>
        <div className="flex items-center gap-5 text-xs font-mono">
          <a href={anchor("terminal-data")} data-testid="nav-data-link" className="hidden sm:inline text-mut hover:text-white transition-colors">
            DATA
          </a>
          <Link to="/directory" data-testid="nav-directory-link" className="hidden sm:inline text-mut hover:text-white transition-colors">
            DIRECTORY
          </Link>
          <Link to="/explainers" data-testid="nav-explainers-link" className="hidden sm:inline text-mut hover:text-white transition-colors">
            TOPICS
          </Link>
          <a href={anchor("terminal-news-feed")} data-testid="nav-news-link" className="hidden sm:inline text-mut hover:text-white transition-colors">
            NEWS
          </a>
          <a
            href={anchor("terminal-enquiry")}
            data-testid="nav-portal-cta"
            className="px-3 py-1.5 rounded bg-cy text-navy font-bold hover:bg-cy-soft transition-colors"
          >
            PORTAL
          </a>
        </div>
      </div>
    </nav>
  );
};
